module.exports = __webpack_public_path__ + "components/flag/static/square/bn-d4095515ca037c084ff0908772543b1c.svg";